// extracted by mini-css-extract-plugin
module.exports = {"cardDetailsLink":"BtnBlock_cardDetailsLink__FUG6O"};